import { ReactNode, useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { format } from "date-fns";
import { useManageModal } from "../../../Manage/components/ManageModal";
import { useSlideInContext } from "../../../../context/SlideInContext";
import { studentData, useStudentContext } from "../../../../context/studentContext";
import usePersonAuthStore, { decodedToken } from "../../../store/personAuthStore";
import SendIcon from '@mui/icons-material/Send';
import usePersonStore from "../../../store/personStore";
type SEND_SESSION_REQUEST_ACTION = "local" | "redirect" | "notification";
type SCREEN_VERSION = "tScreen" | "TweenScreen" | "TeenScreen";
function LaunchButton({ action: actionType, currentAction: action, onAction, screen: screenType, currentAction: screen, children }: {
  action: SEND_SESSION_REQUEST_ACTION,
  currentAction: SEND_SESSION_REQUEST_ACTION | null,
  screen: SCREEN_VERSION
  currentScreen: SCREEN_VERSION | null
  onAction: (action: SEND_SESSION_REQUEST_ACTION, screen: SCREEN_VERSION) => {}, children: ReactNode
}) {
  return (
    <LoadingButton
      sx={{
        backgroundColor: "primary.main",
        "&:hover": {
          backgroundColor: "primary.light",
        },
        width: 180,
        marginTop: "16px",
        padding: 1,
      }}
      type="submit"
      variant="contained"
      loading={actionType === action}
      loadingPosition="end"
      disabled={Boolean(action)}
      endIcon={<SendIcon />}
      onClick={() => onAction(actionType, screenType)}
    >
      {children}
    </LoadingButton>
  )
}

export default function BulkLaunch() {
  const { openModal } = useManageModal();
  const { disableClosingDrawer, toggleDrawer } = useSlideInContext();
  const { bulkStudents, updateBulkStudents } = useStudentContext();
  const [results, setResults] = useState<{
    success: studentData[],
    error: studentData[]
  }>({
    success: [],
    error: []
  })
  useEffect(() => {
    if (results.success.length + results.error.length === bulkStudents.allStudents.length) {
      if (results.error.length < 1 && results.success.length > 0) {
        updateBulkStudents([], [], [], results.success)
        handleSuccessMessage()
        //if there are no errors
      } else {
        updateBulkStudents([], [], results.error, results.success)
        handlePartialSuccessMessage()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [results])

  const [launchAction, setLaunchAction] = useState<SEND_SESSION_REQUEST_ACTION | null>(null);
  const [screenType, setScreenType] = useState<SCREEN_VERSION | null>(null);
  const locationId = usePersonStore(state => state.company.defaultLocation?.id);
  const accessToken = usePersonAuthStore((state) => state.access_token);

  const handleLaunch = async (action: SEND_SESSION_REQUEST_ACTION, screenType: SCREEN_VERSION) => {

    // Prevent accidental closing of the application drawer
    disableClosingDrawer(true);

    setLaunchAction(action);
    setScreenType(screenType)
    if (accessToken) {
      bulkStudents.allStudents.forEach(async (student) => {
        if (action === "notification") {
          openModal({ type: "REMOTE_LAUNCH_INITIALIZED", eventType: 'DISABLE_BACKDROP_AND_CTA', cancelButtonLabel: "Close" });
          // await sleep(1000 * 10)
        }

        const { pid, lid } = decodedToken(accessToken);
        const resposne = await fetch(`${window.__env.API_URL}/api/session/send`, {
          method: "post",
          headers: {
            Pid: pid,
            Lid: locationId ?? lid,
            "Content-Type": "application/json",
            authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            action: action,
            type: screenType,
            studentId: student.id,
            email: student.email,
            enteredAt: format(new Date(), "yyyy-MM-dd'T'HH:mm:ssXXX")
          }),
        });

        if (resposne.status === 202) {
          setResults(prevResults => ({
            ...prevResults,
            success: [...prevResults.success, student]
          }))
          return;
        } else {
          setResults(prevResults => ({
            ...prevResults,
            error: [...prevResults.error, student]
          }))
        }
      })

    }
    // Sleep for a simulated 10 seconds if intent is to send an email

    disableClosingDrawer(false);
    setLaunchAction(null);
  };

  const handleSuccessMessage = () => {
    toggleDrawer();
    disableClosingDrawer(false);
    openModal({ type: "REMOTE_LAUNCH_SUCCESS", eventType: 'DISABLE_BACKDROP', cancelButtonLabel: "Close" });
  };

  const handlePartialSuccessMessage = () => {
    toggleDrawer();
    disableClosingDrawer(false);
    openModal({ type: "REMOTE_LAUNCH_PARTIAL_SUCCESS", students: results.error, eventType: 'DISABLE_BACKDROP', cancelButtonLabel: "Close" })
  }
  return (
    <Grid
      container
      spacing={8}
      direction="column"
      alignItems="center"
      sx={{ padding: "36px 16px", textAlign: "center" }}
    >
      <Grid size={12} direction="column" alignItems="center">
        <Typography>Send a secure email to each <strong>child's </strong>email on file so the child can take the assessment remotely</Typography>
        <Typography>Select either TweenScreen or tScreen</Typography>
      </Grid>
      <Grid size={12} sx={{ display: "flex", flexDirection: "column" }} direction="column" alignItems="center">
        {/* <LaunchButton
          action="notification"
          currentAction={launchAction}
          onAction={handleLaunch}
        >
          tScreen <br />(ages 5-9)
        </LaunchButton> */}
        <LaunchButton
          action="notification"
          currentAction={launchAction}
          screen="TweenScreen"
          currentScreen={screenType}
          onAction={handleLaunch}
        >
          TweenScreen <br /> (ages 9-16)
        </LaunchButton>
      </Grid>
    </Grid>
  );
}
